<template>
    <div id="clube">

        <vs-row vs-w="12" class="mb-5">
            <h3>Clube Vila Galé</h3>
        </vs-row>
        <br>
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="12" vs-xs="12">
                <p class="mb-1">Cartão:</p>
                <v-select
                    class="selectWidth360"
                    v-model="cardSelected" 
                    name="cardSelected"
                    autocomplete
                    id="cardSelected_id" 
                    ref="cardSelected_id"
                    :clearable="false" 
                    :options="cards"
                    label="name"
                    v-validate="'required'"
                >
                    <span slot="no-options">{{$t('vSelectNoResults')}}</span>
                </v-select>
            </vs-col>
        </vs-row>

        <vs-table
        stripe
        search
        pagination
        max-items="10"        
        noDataText="Não foram encontrados registos"
        :data="cardInfo"
        :key="tableKey"
        v-if="cardSelected"
        >
            <template slot="thead">
                <vs-th sort-key="name">
                    Designação
                </vs-th>
                <vs-th sort-key="family_sort">
                    Família
                </vs-th>
                <vs-th sort-key="sub_family_sort">
                    Sub-Família
                </vs-th>
                <vs-th sort-key="item_group_sort">
                    Grupo
                </vs-th>
                <vs-th sort-key="item_sort">
                    Artigo
                </vs-th>
                <vs-th sort-key="discount">
                    Desconto
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td>
                        {{tr.name}} 
                    </vs-td>

                    <vs-td>
                        {{tr.family.familia}} 
                    </vs-td>

                    <vs-td>
                        {{tr.sub_family.sub_familia}}
                    </vs-td>
                    <vs-td>
                        {{tr.item_group ? data[indextr].item_group.item_grupo : '---'}}
                    </vs-td>
                    <vs-td>
                        {{tr.item ? data[indextr].item.name : '---'}}
                    </vs-td>
                    <vs-td>
                        {{tr.discount}}%
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        
    </div>
</template>

<script>
    import themeConfig from '@/../themeConfig.js';
    import axios from 'axios';

    export default {
        data: function() {
            return {
                token: null,
                cards: [],
                cardSelected: null,
                cardInfo: [],
                tableKey: 0,
            }
        }, 
        components: {

        },
        methods: {
            loadCards(){
                this.$vs.loading();
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/loyalty/card/list',
                    params: {
                        token: that.token,
                    }         
                }).then(function (res) {
                    that.cards = res.data;
                }).catch( function (err) {
                    that.notify('Erro a carregar os cartões', 'red');
                }).then(function(){
                    that.$vs.loading.close();
                });
            },
            loadCardInfo(){
                this.$vs.loading();
                let that = this;

                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/loyalty/discount',
                    params: {
                        token: that.token,
                        cod_card: that.cardSelected.cod_card,
                    }         
                }).then(function (res) {
                    that.tableKey++;
                    that.cardInfo = res.data.map( function(value) {
                        value.family_sort = value.family.familia;
                        value.sub_family_sort = value.sub_family.sub_familia;
                        value.item_group_sort = value.item_group ? value.item_group.item_grupo : '';
                        value.item_sort = value.item ? value.item.name : '';
                        return value;
                    });
                    that.cardInfo.sort((a, b) => b['discount']-a['discount']);
                }).catch( function (err) {
                    that.notify('Erro a carregar os dados do cartão selecionado', 'red');
                }).then(function(){
                    that.$vs.loading.close();
                });
            },
        }, 
        mounted: function() { 

        } ,   
        created() {
            this.token = window.localStorage.getItem('usertoken');
            this.loadCards();
        }, 
        computed: {

        },
        watch: {
            cardSelected: function(new_val, old_val) {
                this.loadCardInfo();
            },
        },
    }
</script>


<style>
    #clube .vs-table--thead tr{
        color: white !important;
        background-color: rgb(var(--vs-primary)) !important;
    }

</style>
